function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M42.626 18c-.224-.763-.396-1.437-.502-2h-6.207c-.085.595-.234 1.268-.429 2H42.626zM42.14 14C42.583 12.089 44 9.69 44 8c0-2.761-2.239-5-5-5s-5 2.239-5 5c0 1.69 1.417 4.089 1.86 6H42.14zM43.249 20h-8.353c-.336 1.054-.723 2.18-1.118 3.324C35.192 25.896 36 28.851 36 32c0 4.416-1.586 8.451-4.214 11.578C31.911 44.462 32 45 32 45c0 1.105 3.134 2 7 2s7-.895 7-2c0 0 1-6 1-11C47 30.629 44.73 24.535 43.249 20z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18,16C9.147,16,2,23.147,2,32s7.147,16,16,16s16-7.147,16-16S26.853,16,18,16z M18,33c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2s2,0.895,2,2C20,32.105,19.105,33,18,33z M17.5,26c-1.381,0-2.5-1.119-2.5-2.5c0-1.381,1.119-2.5,2.5-2.5s2.5,1.119,2.5,2.5C20,24.881,18.881,26,17.5,26z M24,29c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2s2,0.895,2,2C26,28.105,25.105,29,24,29z"
});

function SvgBowling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowling);
export default __webpack_public_path__ + "static/media/bowling.dc095e42.svg";
export { ForwardRef as ReactComponent };